import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './auth.module'
import { users } from './user.module'
import { customers } from './customer.module'
import { contacts } from './contact.module'
import { logs } from './logs.module'
import { staffTimeLogs } from './stafftimelog.module'

import { products } from './product.module'
import { addresses } from './address.module'
import { apierrors } from './apierror.module'
import { priceListDefault } from './price-list-default.module'
import { priceListProject } from './price-list-project.module'
import { priceListCustomer } from './price-list-customer.module'
import { priceList } from './price-list.module'
import { deliveryTemplates } from './delivery-template.module'
import { systemSettings } from './system-settings.module'
import { tags } from './tag.module'
import { userSettings } from './user-settings.module'

import { workOrders } from './work-order.module'
import { workOrdersShare } from './work-order-share.module'
import { workOrdersPerProject } from './work-order-per-project.module'

import { projects } from './project.module'
import { projectsOwner } from './project-owner.module'
import { projectsReviewer } from './project-reviewer.module'
import { projectsInvoice } from './project-invoice.module'

import { invoicesOwner } from './invoice-owner.module'
import { invoicesOverdue } from './invoice-overdue.module'
import { invoicesArchive } from './invoice-archive.module'

import { financeIntegration } from './finance-integration.module'
import { meta } from './meta.module'

import { fortnoxConnectionLogs } from './fortnox-connection-logs.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    loading: false
  },
  modules: {
    auth,
    users,
    customers,
    contacts,
    logs,
    staffTimeLogs,
    products,
    apierrors,
    addresses,
    priceListDefault,
    priceListProject,
    priceListCustomer,
    priceList,
    deliveryTemplates,
    systemSettings,
    tags,
    userSettings,

    workOrders, // Hem » Insatser
    workOrdersShare, // Hem » Dela
    workOrdersPerProject, // Projekt » Kontext » Insatser

    projects,
    projectsOwner,
    projectsReviewer,
    projectsInvoice,

    invoicesOwner,
    invoicesOverdue,
    invoicesArchive,

    financeIntegration,
    meta,

    fortnoxConnectionLogs
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js